import { baseRoutes } from '@routes/helpers/baseRoutes.ts';
import { routesPaths } from '@routes/helpers/constants.ts';
import { AppRouteConfig } from '@routes/route.ts';

export const datapoolsRoutes: ReadonlyArray<AppRouteConfig> = [
  {
    path: baseRoutes.datapools.root,
    lazyImport: () => import('../../domains/protected/datapools/DatapoolsRoute.tsx'),
    requiresAuth: true,
    resourceId: 'datapool',
    children: [
      {
        index: true,
        lazyImport: () =>
          import('../../domains/protected/datapools/pages/datapools-list/DatapoolsListRoute.tsx'),
        nav: {
          hideBack: true,
          breadcrumbKey: 'list'
        }
      },
      {
        path: baseRoutes.datapools.details,
        lazyImport: () =>
          import('../../domains/protected/datapools/pages/datapool-details/DatapoolDetailsRoute.tsx'),
        nav: {
          backTo: routesPaths.datapools.root,
          breadcrumbKey: 'details'
        }
      },
      {
        path: '*',
        redirectTo: routesPaths.datapools.root
      }
    ]
  }
];
